import FeatureGates from "@atlassian/feature-gate-js-client";
import UFOSegment from "@atlassian/wac-ufo-segment";

import { TypographyStyles } from "@/libraries/wpl/foundations/src";
import GlobalFooterPattern from "@/patterns/global-footer/src/index";
import GlobalFooter from "@/patterns/global-footer-v2/src";
import GlobalNavigation from "@/patterns/global-nav/src/index";
import GlobalNav from "@/patterns/global-nav-v2/src";

import {
    Cards,
    Careers,
    Carousel,
    Hero,
    LiftedBanner,
    SocialProof,
    HeroTeam24Promotion
} from "./sections";
import {
    FutureOfTeamwork,
    AtlassianIntelligence,
    CustomerStories,
    GetStartedCTA,
    HeroJiraCTA,
    ScrollPinnedSections,
    TabsSection,
    Team24BannerAlert,
    Team24Promo,
    TeamStats
} from "./sections-v2";

export const HomePageTemplate = () => {
    const isTeam24Homepage = FeatureGates.checkGate(
        "wac-homepage-team24-rollout-gate"
    );

    const isTeam24PromotionHero = FeatureGates.checkGate(
        "wac-team-24-promotion-hero-and-banner"
    );

    const isShowTryNowLink: boolean = FeatureGates.getExperimentValue(
        "wac-globalui-team24-globalnav-cta",
        "isShowTryNowLink",
        true
    );

    if (isTeam24Homepage) {
        return (
            <UFOSegment name="home-page-v2">
                <div>
                    <Team24BannerAlert />
                    <GlobalNav
                        productKey={"home"}
                        isShowTryNowLink={isShowTryNowLink}
                    />
                    <TypographyStyles>
                        <HeroJiraCTA />
                        <ScrollPinnedSections />
                        <AtlassianIntelligence />
                        <TeamStats />
                        <TabsSection />
                        <CustomerStories />
                        <Team24Promo />
                        <FutureOfTeamwork />
                        <GetStartedCTA />
                    </TypographyStyles>
                    <GlobalFooter />
                </div>
            </UFOSegment>
        );
    }
    return (
        <UFOSegment name="home-page">
            <div>
                <GlobalNavigation showTryNow={true} productKey={"home"} />
                {isTeam24PromotionHero ? <HeroTeam24Promotion /> : <Hero />}
                <LiftedBanner />
                <Carousel />
                <SocialProof />
                <Cards />
                <Careers />
                <GlobalFooterPattern />
            </div>
        </UFOSegment>
    );
};
